export const LOADED_DATA = new Map()
